<template>
  <Navigation />
  <router-view :user="user" />
</template>

<script>
import Navigation from "./components/Navigation.vue";
import db from "./db.js";
// import { library } from "@fortawesome/fontawesome-svg-core";
// import { faUserSecret} from "@fortawesome/free-solid-svg-icons";

export default {
  name: "app",
  data: function () {
    return {
      user: null,
    };
  },
  components: {
    Navigation,
  },
  mounted() {
    // library.add(faUserSecret);
    db.collection("profile")
      .doc("1")
      .onSnapshot((snapshot) => {
        const doc = snapshot.data();
        this.user = doc;
        console.log("this is user", this.user);
        // this.title = doc.title;
        // this.name = doc.name;
        // this.desc = doc.bio;
        // this.photo = doc.photo;
        // console.log(doc.photo);
      });
  },
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap";
.back {
  background-color: #f5f5f5;
}
</style>